module.exports = __webpack_public_path__ + "media/images/background_solutions-3e46ddc2.jpg";